<template>
    <div class="mt-10 rounded-3xl overflow-hidden bg-stone-100">
        <Image
            :src="post.getCoverImageUrl() ?? ''"
            :alt="post.title"
            class="w-full h-auto object-cover"
        />
    </div>
</template>

<script setup lang="ts">
    import CMSArticle from '@/CMS/Content/Entity/CMSArticle'
    import Image from '@/Shared/Component/Image.vue'

    interface BlogPostCoverImageProps {
        post: CMSArticle
    }

    defineProps<BlogPostCoverImageProps>()
</script>
